import {createRouter, createWebHashHistory} from 'vue-router'

const routes = [
    {
        path: '/login',
        name: 'login',
        meta: {title: '商户登录'},
        component: () => import('../views/login.vue')
    },
    {
        path: '/',
        name: 'main',
        component: () => import("@/layout/index.vue"),
        redirect: '/admin/payCode',
        children: [
            {
                path: '/admin/payCode',
                name: 'payCode',
                meta: {title: '收款码'},
                component: () => import('../views/admin/payCode/payCode.vue')
            }
        ]
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})
export {routes}
export default router
